import {useMsal} from '@azure/msal-react';
import Button from '@mui/material/Button';
import type * as React from 'react';
import {loginRequest} from '@/components/MSAL/msalConfig';

export const SignInButton = () : React.ReactElement => {
    const {instance} = useMsal();

    const handleLogin = async () => {
        try {
            await instance.loginRedirect(loginRequest);
        } catch (e : unknown) {
            console.log('error', e);
        }
    };

    return (
        <div>
            <Button
                onClick={async () => {
                    await handleLogin();
                }}
                color="inherit"
            >
                Login
            </Button>
        </div>
    );
};
